import { SettingConst } from '@faire/web-api--source/types';

/**
 * Controls whether or not a retailer is part of the soft credit checkout for higher terms XP
 * https://www.notion.so/faire/Soft-Credit-Checks-for-Higher-Terms-1182efb5c25a804fb97cf01cf47829c7?pvs=4
 */
export const SOFT_CREDIT_CHECK_FOR_HIGHER_TERMS_V2_250211 =
  'SOFT_CREDIT_CHECK_FOR_HIGHER_TERMS_V2_250211' as SettingConst<
    'SOFT_CREDIT_CHECK_FOR_HIGHER_TERMS_V2_250211',
    boolean,
    'RETAILER' | 'HOTJAR_RETAILER' | 'VISITOR_WEB' | 'HOTJAR_VISITOR_WEB'
  >;
